import { render, staticRenderFns } from "./TransferInternalListForm.vue?vue&type=template&id=6574ca48&lang=pug"
import script from "./TransferInternalListForm.vue?vue&type=script&lang=js"
export * from "./TransferInternalListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports